// @flow
import type { ResolvedParams } from '../resolvedParams';
import type { ApiResolvedParams } from './apiResolvedParams';

export default function(apiResolvedParams: ApiResolvedParams): ResolvedParams {
  return {
    notificationId: apiResolvedParams.search_id,
    email: apiResolvedParams.email,
    userControlToken: apiResolvedParams.uct,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/resolvedParams/adapters/resolvedParamsAdapter.js